import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import { Button } from "../GameObjects/Button";
import { KeyboardFocusManager } from "../GameObjects/KeyboardFocusManager";
import { LoadingSpinner } from "../GameObjects/LoadingSpinner";
import { SplashPlayButton } from "../GameObjects/SplashPlayButton";

export class LandingPage extends HLF.State {
    private readonly _bg: PIXI.Sprite;
    private readonly _playBtn: Button;
    private readonly _keyboardFocusManager!: KeyboardFocusManager;
    private readonly _spinner: LoadingSpinner;

    constructor() {
        super();

        this._bg = HLF.PixiUtils.makeSprite("splash");
        this._bg.interactive = true;
        this._bg.cursor = "pointer";
        this._bg.once("pointertap", this.onPlayBtnPressed.bind(this));
        this.addChild(this._bg);

        this._playBtn = new SplashPlayButton(this.onPlayBtnPressed.bind(this));
        this._playBtn.alpha = 0;
        this._playBtn.interactive = false;
        this._playBtn.position.set(0, 180);
        this.addChild(this._playBtn);

        this._spinner = new LoadingSpinner();
        this._spinner.position.set(0, 180);
        this.addChild(this._spinner);

        this._keyboardFocusManager = new KeyboardFocusManager();
        this.addChild(this._keyboardFocusManager);
    }

    public animateIn(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._playBtn, 0.5, {
            alpha: 1,
        });
        timeline.call(() => {
            PubSub.publishSync(HLF.PUSH_KEYBOARD_LAYER, undefined);
            PubSub.publishSync(HLF.REGISTER_FOCUSABLE, this._playBtn);
            this._playBtn.interactive = true;
        });
        timeline.call(pOnComplete);
    }

    public animateOut(pOnComplete: () => void): void {
        this._playBtn.interactive = false;
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this, 1.0, {
            alpha: 0,
        });
        timeline.call(() => {
            this._spinner.destroy({ children: true });
        });
        timeline.call(pOnComplete);
    }

    private onPlayBtnPressed(): void {
        this._bg.interactive = false;
        this._playBtn.interactive = false;
        Application.instance.analytics.event("start", "click");
        const playBtnTimeline: TimelineLite = new TimelineLite();
        playBtnTimeline.to(this._playBtn, 0.5, {
            alpha: 0,
        });
        playBtnTimeline.call(this._spinner.show, undefined, this._spinner, 0);
        playBtnTimeline.call(() => {
            PubSub.publishSync(HLF.UNREGISTER_FOCUSABLE, this._playBtn);
            PubSub.publishSync(HLF.POP_KEYBOARD_LAYER, undefined);
            // TODO:SH: Do we need to reevaluate load screen cleanup/destroy?
            this._keyboardFocusManager.destroy({ children: true });
            PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
                Constants.STATE_GAME, undefined, ...HLF.StateToken.TRANSITION_ANIM_OLD_OUT_REVEAL,
            ));
        });
    }
}
